import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ManageDropdownSm = ({ setShowProfileDropdown, selectedItem, setSelectedItem }) => {

  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownItems = [
    { label: "All", value: "all", path: "/landingpage" },
    { label: "Zones", value: "zones", path: "/managepod" },
    { label: "Units", value: "units", path: "/manageunits" },
    { label: "Properties", value: "properties", path: "/manageproperties" },
  ];

  const handleItemClick = (item) => {
    setSelectedItem(item.value);
    if (item.path) {
      navigate(item.path);
    }
    setShowProfileDropdown(false);
  };

  useEffect(() => {
    if (
      location.pathname !== "/manageunits" &&
      location.pathname !== "/managepod" && location.pathname !== "/manageproperties"
    ) {
      setSelectedItem(""); // Clear the selection
    }
  }, [location.pathname, setSelectedItem]);

  return (
    <li className="group border-b-grey border-b last:border-b-0 block md:hidden">
      <div data-testid="user-profile-assets-toggle" className="flex justify-between items-center pr-4 border-b-0" onClick={() => setIsOpen((prev) => !prev)}>
        <div className="flex gap-3 px-4 py-[18px] items-center cursor-pointer group">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="*:dark:stroke-white">
              <path d="M2 6C2 4.59987 2 3.8998 2.27248 3.36502C2.51217 2.89462 2.89462 2.51217 3.36502 2.27248C3.8998 2 4.59987 2 6 2C7.40013 2 8.1002 2 8.63498 2.27248C9.10538 2.51217 9.48783 2.89462 9.72752 3.36502C10 3.8998 10 4.59987 10 6V18C10 19.4001 10 20.1002 9.72752 20.635C9.48783 21.1054 9.10538 21.4878 8.63498 21.7275C8.1002 22 7.40013 22 6 22C4.59987 22 3.8998 22 3.36502 21.7275C2.89462 21.4878 2.51217 21.1054 2.27248 20.635C2 20.1002 2 19.4001 2 18V6Z" stroke="#1E2A2C" strokeWidth="1.5" />
              <path d="M7 19H5" stroke="#1E2A2C" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M13.3137 4.929L11.1716 7.07109C10.5935 7.64915 10.3045 7.93818 10.1522 8.30573C10 8.67327 10 9.08202 10 9.89952L10 19.5564L18.9705 10.5859C19.9606 9.59581 20.4556 9.10079 20.6411 8.52997C20.8042 8.02786 20.8042 7.48699 20.6411 6.98489C20.4556 6.41406 19.9606 5.91904 18.9705 4.929C17.9805 3.93896 17.4855 3.44394 16.9146 3.25847C16.4125 3.09532 15.8717 3.09532 15.3695 3.25847C14.7987 3.44394 14.3037 3.93896 13.3137 4.929Z" stroke="#1E2A2C" strokeWidth="1.5" />
              <path d="M6 22L18 22C19.4001 22 20.1002 22 20.635 21.7275C21.1054 21.4878 21.4878 21.1054 21.7275 20.635C22 20.1002 22 19.4001 22 18C22 16.5999 22 15.8998 21.7275 15.365C21.4878 14.8946 21.1054 14.5122 20.635 14.2725C20.1002 14 19.4001 14 18 14L15.5 14" stroke="#1E2A2C" strokeWidth="1.5" />
            </svg>
          </span>
          <span className="text-dark dark:text-white text-sm font-normal leading-5 tracking-[-0.408px] grow">Assets</span>
        </div>
        <div className="iconHolder">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M19 9L12 15L5 9" stroke="black" strokeOpacity="0.87" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="dark:stroke-white" />
          </svg>
        </div>
      </div>

      <div className={`dropdownMenuHolder w-full ${isOpen ? "block" : "hidden"}`}>
        <ul className="w-full">
          {dropdownItems.map((item, index) => (
            <li
              key={item.value}
              data-testid={`user-profile-assets-${item.value}`}
              onClick={() => handleItemClick(item)}
              className={`pl-16 pr-4 py-[18px] text-dark-grey dark:text-white text-xs text-left leading-4
              lg:text-sm lg:leading-5 font-normal tracking-[-0.408px] border-b border-grey cursor-pointer
              ${index === 0 ? "border-y" : ""} last:border-b-0 flex justify-between items-center gap-2`}
            >
              <span>{item.label}</span>
              {selectedItem === item.value && (
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M8.49215 15C8.24102 15 8.00244 14.8995 7.82665 14.7238L4.27311 11.1702C3.90896 10.8061 3.90896 10.2033 4.27311 9.8392C4.63725 9.47506 5.23997 9.47506 5.60412 9.8392L8.49215 12.7272L14.9463 6.27311C15.3104 5.90896 15.9132 5.90896 16.2773 6.27311C16.6414 6.63725 16.6414 7.23997 16.2773 7.60412L9.15766 14.7238C8.98186 14.8995 8.74329 15 8.49215 15Z" fill="#FF8C65" />
                  </svg>
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

export default ManageDropdownSm;